import { Form } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

const Option = (props) => {
    const inputnameRef = useRef();
    const value = useRef();
    const image = useRef();
    const [preview, setPreview] = useState(null);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (props.options) {
            setOptions(props.options.map((o) => ({ value: o.id, label: o.name })));
        }
    }, []);

    const onChangeInputs = (e) => {
        const file = image.current?.files?.[0] || null;

        if (file) {
            setPreview(URL.createObjectURL(file));
        }
        if (props.generalOptionId) {
            props.getOptionData({
                id: props.index,
                generalOptionId: props.generalOptionId,
                generalOptionName: inputnameRef.current.value,
                value: +value.current.value,
                group: props.groupIndex,
            });
        } else {
            props.getOptionData({
                id: props.index,
                image: image.current.files[0],
                name: inputnameRef.current.value,
                value: +value.current.value,
                group: props.groupIndex,
            });
        }
    };

    return (
        <div className="option mb-2" style={{ display: "flex", gap: 5 }}>
            <Form.Group className="mb-3" controlId="optionName">
                <Form.Label>
                    الاختيارت<span style={{ color: "red" }}>*</span>
                </Form.Label>
                {!props.option.createdAt && props.generalOptionId ? (
                    <>
                        <Form.Control
                            type="text"
                            onChange={onChangeInputs}
                            ref={inputnameRef}
                            defaultValue={props.generalOptionName}
                            placeholder="الأسم"
                            required
                        />
                    </>
                ) : (
                    <>
                        <Form.Control
                            type="file"
                            onChange={onChangeInputs}
                            style={{ maxWidth: "100px" }}
                            ref={image}
                            placeholder="الصوره"
                        />

                        {(preview || props.option?.image) && (
                            <div
                                style={{
                                    width: 60,
                                    height: 60,
                                    border: "1px solid #ddd",
                                    borderRadius: 4,
                                    marginTop: 8,
                                    overflow: "hidden",
                                }}
                            >
                                <img
                                    src={preview ? preview : props.option?.image}
                                    alt="preview"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>
                        )}
                    </>
                )}
            </Form.Group>
            {props.option.createdAt || !props.generalOptionId ? (
                <Form.Group className="mb-3" controlId="optionName">
                    <Form.Label>
                        الأسم<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={onChangeInputs}
                        ref={inputnameRef}
                        placeholder="الأسم"
                        defaultValue={props.option?.name}
                        required
                    />
                </Form.Group>
            ) : null}
            <Form.Group className="mb-3" controlId="optionName">
                <Form.Label>
                    القيمه (₪)<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                    style={{ maxWidth: "100px" }}
                    type="number"
                    onChange={onChangeInputs}
                    defaultValue={props.option?.value}
                    ref={value}
                    placeholder="...10"
                    required
                />
            </Form.Group>
        </div>
    );
};
export default Option;
